import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Previews = () => {

  const { t } = useTranslation();

  // ENTER TEXT DESCRIPTIONS HERE
  const callouts = [
    {
      name: t("New Arrivals"),
      description: t("Discover the Latest Styles"),
      imageSrc: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/preview/collection_1/collection_1.png',
      imageAlt: 'trending collection #1',
      to: '/collections#collection1',
    },
    {
      name: t('Autumn Essentials'),
      description: t("Step Into Fall with Confidence"),
      imageSrc: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/preview/collection_2/collection_2.png',
      imageAlt: 'trending collection #2',
      to: '/collections#collection2',
    },
  ]

  // stagger motion animation
  const containerMotion = {
    visible: { transition: { staggerChildren: 0.1 } },
  };

  // animation parameters for TEXT
  const textMotion = {
    // movement = FADE-IN + UPWARDS movement
    hidden: { opacity: 0, y: -50 }, // INITIAL STAGE
    visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: 'easeInOut' } }, // ANIMATION STAGE
  };

  // animation parameters for IMAGE
  const imageMotion = {
    // movement = FADE-IN + SLIDE DOWN
    hidden: { opacity: 0 }, // INITIAL STAGE
    visible: { opacity: 1, transition: { duration: 0.5, ease: 'easeInOut' } }, // ANIMATION STAGE
  };

  return (
    <div className="bg-gray-100">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <motion.div className="mx-auto max-w-2xl py-14 lg:max-w-none lg:py-16"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          variants={containerMotion}
        >
          {/* SECTION TEXT */}
          <div className='flex'>
            <motion.h2 className="text-2xl font-bold text-[#291A1A] mr-1.5" variants={textMotion}>
              {t("Explore")}
            </motion.h2>
            <motion.h2 className="text-2xl font-bold text-[#EA6A5E] mr-1.5" variants={textMotion}>
              {t("Trending")}
            </motion.h2>
            <motion.h2 className="text-2xl font-bold text-[#291A1A]" variants={textMotion}>
              {t("Collections")}
            </motion.h2>
          </div>

          {/* REUSABLE TEMPlATE FORMAT */}
          <div className="mt-6 space-y-12 lg:grid sm:grid-cols-2 lg:grid-cols-2 lg:gap-x-6 lg:space-y-0">
            {callouts.map((callout) => (
              <div key={callout.name} className="group relative">
                {/* Collection Image */}
                <motion.div className="relative h-80 w-full overflow-hidden rounded-lg bg-white sm:aspect-h-1 sm:aspect-w-2 lg:aspect-h-1 lg:aspect-w-1 shadow-xl transition-transform duration-300 transform group-hover:scale-95 sm:h-64" variants={imageMotion}>
                  <Link to={callout.to}>
                    <img
                      src={callout.imageSrc}
                      alt={callout.imageAlt}
                      className="h-full w-full object-cover object-center group-hover:opacity-80"
                    />
                  </Link>
                </motion.div>

                {/* TEXT SECTION */}
                <motion.span variants={textMotion}>
                  {/* Collection Title */}
                  <h3 className="mt-6 text-1xl font-none text-[#EA6A5E]">
                    <a href={callout.href}>
                      {callout.name}
                    </a>
                  </h3>

                  {/* Collection Description */}
                  <p className="text-base font-semibold text-[#291A1A]">{callout.description}</p>
                </motion.span>
              </div>
            ))}
          </div>

        </motion.div>
      </div>
    </div>
  )
}

export default Previews